<template>
	<div class="connect-history-cls">
		<div v-if="list.length > 0">
			<section class="block-cls" v-for="(item, index) in list" :key="index">
				<svg-icon :icon-class="item.direction === 'IB' ? 'Visit2' : 'Visit'" />
				<el-button type="text" :disabled="!item.custId" class="expand-cls el-icon-d-arrow-right" @click.stop="handleExpand(item)" :class="isExpand === item.tuid ? 'bottom' : ''"></el-button>
				<div class="header-cls">
					<div class="top">
						<span>{{item.csrUserName}} {{item.direction === 'IB' ? '接待' : ''}} <big>{{getChannelStatus(item.channelId)}}</big> {{item.direction === 'IB' ? '来访' : '出访'}}</span>
						<i @click.stop="handleView(item)" class="link-cls">详情</i>
					</div>
					<div class="bottom">{{item.createdText}}</div>
				</div>
				<el-collapse-transition>
					<div class="content-cls" v-if="isExpand === item.tuid">
						<audio v-if="item.channelIdentify == 'phone'" :src="mp3" class="audio-cls" controls></audio>
						<div class="sms-box" v-else-if="item.channelIdentify == 'sms'">
							<span v-if="smsInfo.sendStatus === 'ready'" class="time" :class="smsInfo.sendStatus">预约时间：{{smsInfo.scheduleTime | formatDate}}2</span>
							<span v-else-if="smsInfo.sendStatus === 'sent'" class="time">发送时间：{{smsInfo.sendTime | formatDate}}</span>
							<span class="text">{{smsInfo.smsBody}}</span>
						</div>
						<div class="im-cls" v-else>
							<historyList :customerId="item.custId" :sessionId="item.tuid" />
						</div>
						
					</div>
				</el-collapse-transition>
			</section>
		</div>
		<el-empty v-else description="暂无数据"></el-empty>
		<el-pagination
			v-if="list.length !== 0"
			@current-change="handleCurrentChange"
			layout="total, prev, pager, next, jumper"
			:total="total"
			:page-size="listQuery.pageSize"
			:pager-count="5">
		</el-pagination>

		<el-dialog title="详情" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="875px">
			<Info v-if="dialogFormVisible" sourceType="historyInfo" :row="row" @closeDialogFormVisible="handleCloseDialogFormVisible" />
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EnumMixin } from "utils/mixins";
import Info from "views/communicate/info";

export default {
	name: 'ComponentCustomerHistory',
	props: ['customerId', 'sourceType', 'tuId'],
	mixins: [EnumMixin],
	components: {Info},
	computed: {
        ...mapGetters([
			'userInfo',
        ])
    },
	watch: {
		customerId: {
			handler(val){
				if(val) {
					this.getList();
				}
			},
			immediate:true
		}
	},
	data() {
		return {
			dialogFormVisible: false,
			isExpand: '',
			total: 0,
			list: [],
			mp3: '',
			listQuery: {
				brandId: '',
				custIds: '',
				searchType: '',
				tuId: '',
				pageNumber: 1,
				pageSize: 10
			},
			row: {},
			smsInfo: {}
		}
	},
	methods: {
		getList() {
			this.listQuery.brandId = this.userInfo.brandIdentify;
			this.listQuery.custIds = this.customerId;
			// this.listQuery.tuid = this.tuId;
			this.$api.apiIaIncidentList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		handleExpand(item) {
			console.log(item, this.isExpand)
			if(this.isExpand === item.tuid) {
				this.isExpand = '';
			} else {
				if(item.channelId == 'phone') {
					if(item.dataList && item.dataList.length > 0) {
						for(const _item of item.dataList) {
							if(_item.dataType === 'UCID') {
								if(item.channelIdentify === 'phone') {
									this.$api.apiPostLarksWitchLocation({
										projectCode: item.brandId,
										uuid: _item.dataId
									}).then(response => {
										if(response.errcode != 0) return;
										this.mp3 = response.data.http_file_url;
									});
								}
							}
						}
					}
				} else if(item.channelId == 'sms') {
					this.$api.apiPostSmsSelByIncident({brand: item.brandId, incidentId: item.tuid}).then(response => {
						if(response.errcode != 0) return;
						this.smsInfo = response?.data?.smsrsult;
					});
				}
				this.isExpand = item.tuid;
			}
		},
		handleCurrentChange(val) {
			this.listQuery.pageNumber = val;
			this.getList();
		},
		handleView(item) {
			this.row = item;
			this.dialogFormVisible = true;
		},
		handleCloseDialogFormVisible() {
			this.dialogFormVisible = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.connect-history-cls {
	width: 100%;
	height: 100%;
	// text-align: center;
	padding: 0 20px;
	box-sizing: border-box;

	& .block-cls {
		width: 100%;
		padding-left: 30px;
		padding-right: 38px;
		box-sizing: border-box;
		position: relative;
		border: 1px solid #E6E9EF;
		background: #F6F7F9;
		margin-bottom: 28px;
		text-align: left;
		border-radius: 3px;

		& > .expand-cls {
			float: right;
			width: 28px;
			height: 28px;
			line-height: 28px;
			text-align: center;
			position: absolute;
			right: 0px;
			font-weight: 900;
			// color: #606266;
			vertical-align: top;
			line-height: 10px;

			&.bottom {
				transform: rotate(90deg) ;
			}
		}

		& > .svg-icon {
			width: 30px;
			height: 30px;
			position: absolute;
			top: 9px;
			left: -15px;
		}

		&::before {
			content: "";
			width: 1px;
			height: 16px;
			background: #A6AAB8;
			position: absolute;
			bottom: -23px;
			left: 0;
		}
		&:last-child::before{
			display: none;
		}

		& > .header-cls {
			width: 100%;
			height: 48px;
			padding: 7px 0;
			box-sizing: border-box;

			& > .top {
				width: 100%;
				height: 16px;
				margin-bottom: 4px;

				& > span{
					vertical-align: top;
					font-size: 14px;
					
					font-weight: 500;
					color: #3C4353;
					line-height: 16px;

					& > big {
						font-size: 14px;
						color: #47B267;
						margin: 0 5px;
					}
				}

				& > .link-cls {
					vertical-align: top;
					float: right;
					font-size: 14px;
					
					font-weight: 400;
					color: #337EFF;
					font-style: normal;
					line-height: 16px;
					margin-left: 8px;
					cursor: pointer;
				}
			}

			& > .bottom {
				height: 16px;
				font-size: 12px;
				
				font-weight: 500;
				color: #C7C7C7;
				line-height: 16px;
			}
		}

		& .content-cls {
			width: calc(100% + 38px + 30px);
			background: #F9FCFF ;
			position: relative;
			left: -30px;
			border-top: 1px solid #DEDFDF;
			padding: 10px;
			box-sizing: border-box;

			& > audio {
				width: 100%;
				height: 35px;
				border-radius: 35px;
				border: 1px solid #DEDFDF;
			}

			& > .im-cls {
				width: 100%;
				height: 240px;
			}

			& > .sms-box {
				width: 100%;
				padding: 12px;
				box-sizing: border-box;
				font-size: 15px;
				color: #333;
				line-height: 30px;
				letter-spacing: .5px;

				& > .time {
					display: block;
					line-height: 40px;
					text-align: center;
					font-size: 12px;

					&.ready {
						color: #e6a23c;
					}
				}

				& > .text {
					text-indent: 2em;
				}
			}
		}
	}
}
</style>
